import React from 'react'
import {Field, reduxForm} from 'redux-form'
import Captcha from '../../Captcha'

const validate = values => {
  const requiredMsg = "Este campo é obrigatório";
  const errors = {};

  if (!values.certificadoAtributo) {
    errors.certificadoAtributo = requiredMsg;
  }

  if (!values.captcharesponse){
    errors.captcharesponse = "Por favor, confirme o Captcha"
  }

  return errors
}

const renderFieldTextArea = ({
                               input,
                               label,
                               placeholder,
                               meta: {touched, error, warning}
                             }) => (
  <div className='form-group'>
    <label htmlFor={input.name}>{label}</label>
    <textarea {...input} id={input.name} placeholder={placeholder} rows="5"
           className={`form-control ${touched && ((error && 'is-invalid'))}`}
    />
    {touched && ((error && <span className='text-danger'>{error}</span>) || (warning &&
      <span className='text-warning'>{warning}</span>))}
  </div>
)

const FormValidadorPorCertificado = props => {
  const {handleSubmit, submitting} = props;
  return (
    <form onSubmit={handleSubmit}>

        <Field name="certificadoAtributo" component={renderFieldTextArea} label="Certificado de Atributo em formato PEM" placeholder='Certificado de Atributo em formato PEM'/>

        <div className="form-group text-center">

          <Field name='captcharesponse' component={Captcha}/>

          <button type="submit" disabled={submitting} className='btn btn-block btn-success'>Validar</button>
        </div>

    </form>
  )
}

export default reduxForm({
  form: 'formValidadorPorCertificado', // a unique identifier for this form
  fields: ['certificadoAtributo', 'captcharesponse'],
  validate // <--- validation function given to redux-form
})(FormValidadorPorCertificado)



// WEBPACK FOOTER //
// ./src/components/views/Validador/FormValidadorPorCertificado.js